import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { Ticket, GetTicketAction } from 'wms-lib';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

@Component({
  selector: 'app-ticket-details',
  templateUrl: './ticket-details.component.html',
  styleUrls: ['./ticket-details.component.scss']
})
export class TicketDetailsComponent implements OnInit {
  @Select((state: any) => state.helpDeskState.active_ticket) ticket$: Observable<Ticket>;
  attachment_columns = [
    { field: 'name', header: 'Filename' },
    { field: 'created_at', header: 'Created At' },
    { field: 'src', header: 'Options' },
  ];

  constructor(private ref: DynamicDialogRef, private config: DynamicDialogConfig, protected store: Store) {
  }

  ngOnInit() {
    if (this.config.data.ticket) this.store.dispatch(new GetTicketAction(this.config.data.ticket.id));
  }

}
